<template>
  <div style="text-align: center;">
    <h3 class="headerTitle">{{ $t("homePage.addmaintenanceservice") }}</h3>
    <el-divider />
    <el-form :model="formData" label-width="190px" class="formBox">
      <div class="selectBox">
        <el-row :gutter="20">
          <el-col :span="6">&nbsp;</el-col>
          <el-col :span="16">
            <el-form-item
              prop="firstLevelService"
              :label="$t('homePage.servicetype') + '：'"
            >
              <el-select
                clearable
                :placeholder="$t('homePage.pleaseselectservicetype')"
                v-model="mainSelectProductService.productCode"
                @change="selectServiceClick"
                class="Ipts"
              >
                <el-option
                  v-for="item in mainServiceList"
                  :key="item.productCode"
                  :label="item.productName"
                  :value="item.productCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">&nbsp;</el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">&nbsp;</el-col>
          <el-col :span="16">
            <el-form-item
              prop="firstLevelService"
              :label="$t('homePage.lengthofservice') + '：'"
            >
              <el-select
                clearable
                :placeholder="$t('homePage.pleaseselectserviceduration')"
                v-model="mainSelectProductService.selectedYear"
                @change="serviceNumChange"
                class="Ipts"
              >
                <el-option
                  v-for="item in mainServiceYearList"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="false">
          <el-col :span="6">&nbsp;</el-col>
          <el-col :span="16">
            <el-form-item label="市场零售价（元）：">
              {{ mainSelectProductService.listPrice }}
            </el-form-item>
          </el-col>
          <el-col :span="6">&nbsp;</el-col>
        </el-row>
      </div>
      <el-divider />
      <div class="selectBox" v-if="secondaryServiceList.length > 0">
        <div v-for="(s, index) in secondaryServiceList" :key="index">
          <el-row :gutter="20">
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="16">
              <el-form-item :label="$t('homePage.servicetype') + '：'">
                <el-select
                  class="Ipts"
                  clearable
                  :placeholder="$t('homePage.pleaseselectservicetype')"
                  v-model="secondarySelectServiceList[index].productCode"
                  @change="
                    secondarySelectServiceClick(
                      s,
                      index,
                      secondarySelectServiceList[index]
                    )
                  "
                >
                  <el-option
                    v-for="sp in s.serviceProductList"
                    :key="sp.productCode"
                    :label="sp.productName"
                    :value="sp.productCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="16">
              <el-form-item
                prop="firstLevelService"
                :label="$t('homePage.lengthofservice') + '：'"
              >
                <el-select
                  class="Ipts"
                  clearable
                  v-model="secondarySelectServiceList[index].selectedYear"
                  :placeholder="$t('homePage.pleaseselectserviceduration')"
                  @change="
                    secondaryServiceNumChange(
                      secondarySelectServiceList[index].selectedYear,
                      index
                    )
                  "
                >
                  <el-option
                    v-for="y in secondarySelectServiceList[index].yearList"
                    :key="y"
                    :label="y"
                    :value="y"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-divider />
        </div>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">&nbsp;</el-col>
        <el-col :span="12" class="position-right">
          <el-form-item>
            <el-button @click="cancel">
              {{ $t("homePage.takeAway") }}
            </el-button>
            <el-button type="primary" @click="onSubmit">
              {{ $t("homePage.save") }}
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6">&nbsp;</el-col>
      </el-row>
    </el-form> 
  </div>
</template>
  
<script>
// 导入多个服务配置  
import { MultipleServiceConfigIndex } from "./index";
export default {
  mixins: [MultipleServiceConfigIndex], // 混入 mixins
};
</script>
    
    <style lang="less" scoped>
.service-num {
  margin-top: 17px;
  display: flex;
  justify-content: left;
  align-items: center;
  .province-span {
    width: 130px;
    text-align: right;
  }
}
.service-price {
  margin-top: 17px;
  display: flex;
  justify-content: left;
  align-items: center;
  .province-span {
    width: 130px;
    text-align: right;
  }
}
.selectBox{
    padding-left:60px ;
    text-align: center;
  }
  // 每一行 label 选项的宽度  
  .Ipts{ 
    width: 235px;
  }
  // 按钮位置
  .formBox{
    position: relative;
  }
  // // 按钮位置
  .position-right{
    position: absolute;
    width: 100%;
    right: -137px;
    bottom: -38px;
    // text-align: right !important;
  }
  .headerTitle{
    text-align: left  !important;
    margin-top: -35px;
    line-height: 15px;
  }
</style>
    